import { hasFeature } from '@/utils/featureFlag';

export const AUTH_ROUTES = {
  signIn: '/sign-in',
  signUp: '/sign-up',
  profile: '/sign-up/profile',
  forgotPassword: '/forgot-password',
};

export const AUTH_ROUTES_WITHOUT_SIGN_UP = {
  signIn: '/sign-in',
  profile: '/sign-in/profile',
  forgotPassword: '/forgot-password',
};

export const AUTH_ROUTES_PATHS = hasFeature('signUp')
  ? Object.values(AUTH_ROUTES)
  : Object.values(AUTH_ROUTES_WITHOUT_SIGN_UP);
